export default __webpack_public_path__ + "assets/pdf/FT_ZNKu.223e7e29.pdf";